<app-carrier-form-wrapper
  #formWrapper
  data-testid="carrier-form-wrapper"
  [config]="config()"
  [editMode]="editMode()"
  [viewMode]="viewMode()"
></app-carrier-form-wrapper>

